import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37dd6f67"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  class: "instruction"
};
const _hoisted_3 = {
  class: "stem",
  "aria-label": "题干"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "blank"
}, "____", -1));
const _hoisted_5 = {
  class: "option-grid",
  role: "radiogroup",
  "aria-label": "答案选项"
};
const _hoisted_6 = ["aria-checked", "disabled", "onClick"];
const _hoisted_7 = {
  class: "option-key"
};
const _hoisted_8 = {
  class: "option-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", {
    class: "analogy-card",
    "aria-label": $options.instructionText
  }, [_createElementVNode("p", _hoisted_2, _toDisplayString($options.instructionText), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString($options.stemParts[0]), 1), _hoisted_4, _createElementVNode("span", null, _toDisplayString($options.stemParts[1]), 1)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.normalizedOptions, option => {
    return _openBlock(), _createElementBlock("button", {
      key: option.key,
      class: _normalizeClass(["option-card", $options.optionClass(option.key)]),
      type: "button",
      role: "radio",
      "aria-checked": $data.selected === option.key,
      disabled: !$props.interactive || $props.reviewMode,
      onClick: $event => $options.choose(option.key)
    }, [_createElementVNode("span", _hoisted_7, _toDisplayString(option.key), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(option.text), 1)], 10, _hoisted_6);
  }), 128))])], 8, _hoisted_1);
}